export default {"src":"/_next/static/media/watch-moderate.27ad407d.svg","height":80,"width":25};